export const state = {
  isLoading: false,
  currentStep: null,
  responses: {},
  errors: {}
};

export const actions = {
  // Call Lambda by slug with parameters
  async callLambdaBySlug({ state, effects }, { slug, parameters }) {
    state.isLoading = true;
    state.currentStep = slug;
    
    try {
      const response = await effects.lambda.callBySlug(slug, parameters);
      
      state.responses[slug] = response;
      state.errors[slug] = null;
      
      return response;
    } catch (error) {
      state.errors[slug] = error.message;
      throw error;
    } finally {
      state.isLoading = false;
    }
  },

  // Generic method for any Lambda call
  async callLambda({ state, effects }, { url, method = 'GET', queryParams = {}, body = null, customHeaders = {} }) {
    state.isLoading = true;
    
    try {
      const response = await effects.lambda.callLambda(url, method, queryParams, body, customHeaders);
      state.errors[url] = null;
      return response;
    } catch (error) {
      state.errors[url] = error.message;
      throw error;
    } finally {
      state.isLoading = false;
    }
  },

  clearLambdaData({ state }) {
    state.responses = {};
    state.errors = {};
    state.currentStep = null;
  },

  // Get all responses for final API call
  getAllResponses({ state }) {
    return state.responses;
  }
};

// Effects are now defined in src/store/effects/lambda.js

